export const MAX_SPACE_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const MAX_SPACE_FOLDER_DEPTH = 7;

export const MAX_INTERNAL_WORKSPACES = 50;

export const MAX_HOME_DATA_ROOMS = 100;

// A navigation folders request returns one level, plus each folder's children at depth 2.
export const MAX_NAVIGATION_FOLDERS_DEPTH = 2;

export const MAX_SPACE_NAME_LENGTH = 50;

export const MAX_SPACE_DESCRIPTION_LENGTH = 100;

export const MAX_NODE_NAME_LENGTH = 50;

export const SPACE_FOLDER_PAGE_SIZE = 50;

export const MAX_SPACE_FILE_UPLOAD_BATCH = 20;

export const MAX_SHARE_RECIPIENTS_PER_REQUEST = 50;
